import React from "react"
import PropTypes from "prop-types"
import RatingStat from "../rating-stat/RatingStat"
import { GroupContainer } from "./styles"

const RatingStatGroup = ({ ratings }) => {
  return (
    <GroupContainer ratings={ratings.length}>
      {ratings.map((rating) => (
        <RatingStat {...rating} />
      ))}
    </GroupContainer>
  )
}

RatingStatGroup.propTypes = {
  ratings: PropTypes.arrayOf(
    PropTypes.shape({
      rating: PropTypes.number.isRequired,
      outOf: PropTypes.number.isRequired,
      title: PropTypes.string
    })
  )
}

RatingStatGroup.defaultProps = {
  ratings: [
    {
      rating: 0,
      outOf: 10,
      title: null
    },
    { rating: 0, outOf: 10, title: null }
  ]
}

export default RatingStatGroup
